import { FC } from "react";
import { Box } from "@mui/material";
import { useNotificationSlice } from "@store/slices/notification";
import NotificationCard from "./NotificationCard";

const NotificationStack: FC = () => {
    const { notifications } = useNotificationSlice();

    if (notifications.length === 0) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                bottom: 40,
                left: 20,
                zIndex: 9999,
                maxHeight: "80vh",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column-reverse",
            }}
        >
            {notifications.map((notification) => (
                <NotificationCard key={notification.id} notification={notification} />
            ))}
        </Box>
    );
};

export default NotificationStack;
